export default __webpack_public_path__ + "fonts/Roboto-300-cyrillic2.woff2";